import { NEW_ADMIN_URL } from 'environment';

angular
.module('app.views')
.config(($routeProvider) => {
    $routeProvider.when('/accounts/:account_id/channels/:channel_id/tickets/:id', {
        template: require('./channel_ticket.html'),
        controller: 'ChannelTicketController'
    });
})
.controller('ChannelTicketController', function($scope, $location, $q, $routeParams, $modal, Account, AccountChannel, ChannelTicket){
  $scope.account = Account.get({id: $routeParams.account_id});
  $scope.newAdminURL = NEW_ADMIN_URL;
  $scope.channel = AccountChannel.get({account_id: $routeParams.account_id, id: $routeParams.channel_id, include_archived: true});
  $scope.ticket = ChannelTicket.get({channel_id: $routeParams.channel_id, id: $routeParams.id});

  $q.all([$scope.channel.$promise, $scope.ticket.$promise]).then((res) => {
    let c = res[0], id = res[1].id;
    $scope.showURL = c.admin_viewer_url.replace(/\/\.[0-9A-Za-z]+$/, `/${id}`).replace('/view/', '/channel/');
  });

  $scope.isRefunding = false;
  return $scope.refund = function() {
    if (confirm('Are you sure you want to refund this ticket?')) {
      $scope.isRefunding = true;
      return ChannelTicket.refund({channel_id: $routeParams.channel_id, id: $routeParams.id}, null, (data=> $scope.ticket = data));
    }
  };
});



// WEBPACK FOOTER //
// ./views/channel/channel_ticket_controller.js